type LettersReplacingMap = {
    [key: string]: string;
};

const lettersReplacingMap: LettersReplacingMap = {
    I: '1',
    О: '0',
    O: '0',
    Q: '0',
};

/**
 * Replaces invalid characters in a Vehicle Identification Number (VIN) with their corresponding valid characters.
 * 
 * @param vin - The VIN string to be processed.
 * @returns The VIN string with invalid characters replaced.
 */
export const replacingInvalidVinCharacters = (vin: string): string => {
    let result = '';

    for (let char of vin) {
        if (lettersReplacingMap[char]) {
            result += lettersReplacingMap[char];
        } else {
            result += char;
        }
    }

    return result;
};